/**
 * Coach goal writes (create, update, delete, log progress) through the global apiClient.
 * Non-throwing; success responses carry the snake_case `goal` row that GlobalStateProvider maps.
 */

import { api, type ApiResponse } from '@/lib/apiClient';

type GoalResponse = ApiResponse & { goal?: Record<string, any> };
const goalUrl = (goalId: string, extra = '') => `/api/coach/goals?goalId=${encodeURIComponent(goalId)}${extra}`;

export function createGoal(body: Record<string, unknown>): Promise<GoalResponse> {
  return api.post('/api/coach/goals', body);
}

/** `updates` is already snake_case (the handler writes these columns directly). */
export function updateGoal(goalId: string, updates: Record<string, unknown>): Promise<GoalResponse> {
  return api.put(goalUrl(goalId), updates);
}

export function deleteGoal(goalId: string): Promise<ApiResponse> {
  return api.delete(goalUrl(goalId));
}

/** Adds a (possibly negative) delta to the goal's current value. */
export function addGoalProgress(goalId: string, value: number, note?: string): Promise<GoalResponse> {
  return api.patch(goalUrl(goalId, '&action=progress'), { value, note });
}
